import { render, staticRenderFns } from "./AuthorAds.vue?vue&type=template&id=0ba8bb6b&lang=html&"
import script from "./AuthorAds.vue?vue&type=script&lang=js&"
export * from "./AuthorAds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports